module.exports = __webpack_public_path__ + "img/open-icon.eb5f0837.svg";